import {
	CREATE_SPIN_GAME_REQUEST,
	CREATE_SPIN_GAME_SUCCESS,
	CREATE_SPIN_GAME_FAIL,
	FETCH_SPIN_GAMES_REQUEST,
	FETCH_SPIN_GAMES_SUCCESS,
	FETCH_SPIN_GAMES_FAIL,
	UPDATE_SPIN_GAME_REQUEST,
	UPDATE_SPIN_GAME_SUCCESS,
	UPDATE_SPIN_GAME_FAIL,
	DELETE_SPIN_GAME_REQUEST,
	DELETE_SPIN_GAME_SUCCESS,
	DELETE_SPIN_GAME_FAIL,
	FETCH_SPIN_GAME_REQUEST,
	FETCH_SPIN_GAME_SUCCESS,
	FETCH_SPIN_GAME_FAIL,
} from "../constants/spinTheWheelGame";

function createSpinGameReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}

	switch (action.type) {
		case CREATE_SPIN_GAME_REQUEST:
			return { loading: true };
		case CREATE_SPIN_GAME_SUCCESS:
			return { loading: false, success: true, spinGame: action.payload.data };
		case CREATE_SPIN_GAME_FAIL:
			return { loading: false, success: false, error: action.payload };
		default:
			return state;
	}
}

function fetchSpinGamesReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			spinGameUpdated: false,
			error: null,
			spinGameDeleted: false,
		};
	}
	switch (action.type) {
		case FETCH_SPIN_GAMES_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SPIN_GAMES_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinGames: action.payload,
			};
		case FETCH_SPIN_GAMES_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateSpinGameReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", error: null, spinGameUpdated: false };
	}
	switch (action.type) {
		case UPDATE_SPIN_GAME_REQUEST:
			return { loading: true };
		case UPDATE_SPIN_GAME_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinGameUpdated: true,
			};
		case UPDATE_SPIN_GAME_FAIL:
			return { loading: false, spinGameUpdated: false, error: action.payload };
		default:
			return state;
	}
}

function deleteSpinGameReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case DELETE_SPIN_GAME_REQUEST:
			return { loading: true };
		case DELETE_SPIN_GAME_SUCCESS:
			return {
				loading: false,
				spinGameDeleted: true,
			};
		case DELETE_SPIN_GAME_FAIL:
			return { loading: false, spinGameDeleted: false, error: action.payload };
		default:
			return state;
	}
}

function fetchSpinGameReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
			spinGameUpdated: false,
			spinGameDeleted: false,
		};
	}

	switch (action.type) {
		case FETCH_SPIN_GAME_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SPIN_GAME_SUCCESS:
			console.log("action ", action);
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinGame: action.payload,
			};
		case FETCH_SPIN_GAME_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

export {
	createSpinGameReducer,
	fetchSpinGamesReducer,
	updateSpinGameReducer,
	deleteSpinGameReducer,
	fetchSpinGameReducer,
};
